import { motion } from 'framer-motion'
import { Award, Calendar, ExternalLink, FileText } from 'lucide-react'
import SectionHeader from './SectionHeader'
import { certificates } from '../data/certificates'

const Certificates = () => {
  return (
    <section id="certificates" className="border-y border-academic-line bg-white/45 py-20 md:py-24">
      <div className="section-shell">
        <SectionHeader
          kicker="Certificates"
          title="Professional certificates and completed Coursera training."
        />

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {certificates.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              className="card flex flex-col p-6"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="inline-flex rounded-2xl bg-academic-soft p-3 text-academic-blue">
                  <Award size={21} />
                </span>

                <span className="inline-flex items-center gap-1 rounded-full border border-academic-line px-3 py-1 text-xs text-academic-muted">
                  <Calendar size={13} />
                  {item.date}
                </span>
              </div>

              <h3 className="mt-5 font-semibold leading-6 text-academic-text">
                {item.title}
              </h3>

              <p className="mt-2 text-sm font-medium text-academic-blue">
                {item.issuer}
              </p>

              <p className="mt-3 flex-1 text-sm leading-6 text-academic-muted">
                {item.description}
              </p>

              <a
                href={item.file}
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-2xl border border-academic-line bg-white px-4 py-3 text-sm font-medium text-academic-text transition hover:border-academic-blue hover:text-academic-blue"
              >
                <FileText size={16} />
                View certificate
                <ExternalLink size={14} />
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Certificates